// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__fcDiW","hero-text":"Hero_hero-text__2DmiA","hero-title":"Hero_hero-title__1dpam","hero-description":"Hero_hero-description__3IsAq","cta":"Hero_cta__1JDWd"};